import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
} from "@mui/material";
import axios from "../../utils/axiosInstance";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getUIDescription } from "../SiteAdmin/customerGroupDetails/AssigningCustomerGroupDevice";

export default function EditNotificationGroup({
  open,
  onClose,
  onSubmit,
  groupData,
}) {
  const [groupName, setGroupName] = useState("");
  const [description, setDescription] = useState("");
  // const [parentKey, setParentKey] = useState("");
  // const [regionKey, setRegionKey] = useState("");
  // const [parentGroup, setParentGroup] = useState("");
  // const [region, setRegion] = useState("");
  // const [route, setRoute] = useState("");

  // State for dropdown data
  // const [allGroups, setAllGroups] = useState([]);
  // const [loadingGroups, setLoadingGroups] = useState(false);
  // const [allRegions, setAllRegions] = useState([]);
  // const [loadingRegions, setLoadingRegions] = useState(false);
  // const [allRoutes, setAllRoutes] = useState([]);
  // const [loadingroutes, setLoadingRoutes] = useState(false);

  // Populate form when groupData changes
  useEffect(() => {
    if (groupData) {
      setGroupName(groupData.name || "");
      setDescription(groupData.description || "");
      // setParentKey(groupData.group?.id || "");
      // setRegionKey(groupData.region?.id || null);
      // setParentGroup(groupData.group?.id || "");
      // setRegion(groupData.region?.id || null);
      // setRoute(groupData.route?.id || "");
    }
  }, [groupData]);

  // Fetch groups on mount
  // useEffect(() => {
  //   const fetchGroups = async () => {
  //     try {
  //       setLoadingGroups(true);
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_GATEAWAY}/groups`,
  //         {
  //           params: { companyId: process.env.REACT_APP_COMPANY_ID },
  //         }
  //       );
  //       setAllGroups(response.data);
  //     } catch (err) {
  //       console.error("❌ Error fetching groups:", err);
  //     } finally {
  //       setLoadingGroups(false);
  //     }
  //   };

  //   if (open) {
  //     fetchGroups();
  //   }
  // }, [open]);

  // Fetch regions when parent group changes
  // useEffect(() => {
  //   if (!parentGroup) {
  //     setAllRegions([]);
  //     setRegion("");
  //     return;
  //   }
  //   const fetchRegions = async () => {
  //     try {
  //       setLoadingRegions(true);
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_GATEAWAY}/regions?groupId=${parentGroup}`,
  //         {
  //           params: { companyId: process.env.REACT_APP_COMPANY_ID },
  //         }
  //       );
  //       setAllRegions(response.data);
  //     } catch (err) {
  //       console.error("❌ Error fetching regions:", err);
  //       setAllRegions([]);
  //     } finally {
  //       setLoadingRegions(false);
  //     }
  //   };

  //   fetchRegions();
  // }, [parentGroup]);

  // Fetch routes
  // useEffect(() => {
  //   if (!region) {
  //     return;
  //   }
  //   const fetchRoutes = async () => {
  //     try {
  //       setLoadingRoutes(true);
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_API_GATEAWAY}/routes?regionId=${region}`
  //       );
  //       setAllRoutes(response.data);
  //     } catch (err) {
  //       console.error("❌ Error fetching routes:", err);
  //     } finally {
  //       setLoadingRoutes(false);
  //     }
  //   };

  //   if (open) {
  //     fetchRoutes();
  //   }
  // }, [open, region]);

  const handleUpdateGroup = async () => {
    if (!groupData?.id) {
      toast.error("❌ No group selected for update");
      return;
    }

    try {
      const payload = {
        name: groupName,
        description: description,
        UI_Description: `${getUIDescription()}\n 'update Button on the chosen group (Field Actions)`,
        // groupId: parentGroup,
        // ...(region && { regionId: region }),
        // ...(route && { routeId: route }),
      };

      const response = await axios.put(
        `${process.env.REACT_APP_API_GATEAWAY}/groups/${groupData.id}`,
        payload
      );

      // Create updated notification group object for the parent component
      const updatedNotificationGroup = {
        ...groupData,
        id: response.data.id || groupData.id,
        name: response.data.name || groupName,
        description: response.data.description || description,
        // parentKey: response.data.parentKey || parentKey,
        // regionKey: response.data.regionKey || regionKey,
        // date_updated: response.data.date_updated || new Date().toISOString(),
        // users: response.data.users || groupData.users,
        // devices: response.data.devices || groupData.devices,
        // group: allGroups.find(g => g.id === parentGroup) || groupData.group,
        // region: allRegions.find(r => r.id === region) || groupData.region,
        // route: allRoutes.find(t => t.id === route) || groupData.route,
      };

      if (onSubmit) {
        onSubmit(updatedNotificationGroup);
      }
      toast.success("✅ Notification group updated successfully!");
    } catch (error) {
      console.error("❌ Error updating notification group:", error);
      toast.error(
        error.response?.data?.message ||
          "❌ Failed to update notification group"
      );
    } finally {
      onClose();
    }
  };

  const handleClose = () => {
    onClose();
    // Reset form when closing
    setGroupName("");
    setDescription("");
    // setParentKey("");
    // setRegionKey("");
    // setParentGroup("");
    // setRegion("");
    // setRoute("");
    // setAllRegions([]);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ mt: 1, fontSize: "0.93rem" }}>
        Edit Notification Group: Update group settings and assignments
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 1 }}>
          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Name"
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            fullWidth
            required
          />

          <TextField
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 0, // ✅ remove rounding
              },
            }}
            label="Description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            fullWidth
            multiline
            rows={2}
          />
          {/* 
          <TextField
            label="Parent Key"
            value={parentKey}
            onChange={(e) => setParentKey(e.target.value)}
            fullWidth
            placeholder="Enter parent key"
            disabled
          />

          <TextField
            label="Region Key"
            value={regionKey}
            onChange={(e) => setRegionKey(e.target.value)}
            fullWidth
            placeholder="Enter region key"
            disabled
          />

          <TextField
            select
            label="Parent Group"
            value={parentGroup}
            onChange={(e) => setParentGroup(e.target.value)}
            fullWidth
            disabled={loadingGroups}
            required
          >
            {allGroups.length > 0 ? (
              allGroups.map((group) => (
                <MenuItem key={group.id} value={group.id}>
                  {group.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                {loadingGroups ? "Loading groups..." : "No groups available"}
              </MenuItem>
            )}
          </TextField>

          <TextField
            select
            label="Region/District"
            value={region}
            onChange={(e) => setRegion(e.target.value)}
            fullWidth
            disabled={loadingRegions || !parentGroup}
          >
            <MenuItem value="">
              <em>No Region Selected</em>
            </MenuItem>
            {allRegions.length > 0 ? (
              allRegions.map((regionItem) => (
                <MenuItem key={regionItem.id} value={regionItem.id}>
                  {regionItem.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                {loadingRegions
                  ? "Loading Regions..."
                  : parentGroup
                    ? "No Regions available"
                    : "Select Parent Group first"
                }
              </MenuItem>
            )}
          </TextField>

          <TextField
            select
            label="Route"
            value={route}
            onChange={(e) => setRoute(e.target.value)}
            fullWidth
            disabled={loadingroutes}
          >
            <MenuItem value="">
              <em>No Route Assigned</em>
            </MenuItem>
            {allRoutes.length > 0 ? (
              allRoutes.map((route) => (
                <MenuItem key={route.id} value={route.id}>
                  {route.name || `${route.firstName} ${route.lastName}` || route.email}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                {loadingroutes ? "Loading routes..." : "No routes available"}
              </MenuItem>
            )}
          </TextField> */}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{
            borderRadius: 0, // ✅ remove rounding
          }}
          onClick={handleClose}
          color="error"
        >
          Cancel
        </Button>
        <Button
          sx={{
            borderRadius: 0, // ✅ remove rounding
          }}
          onClick={handleUpdateGroup}
          variant="contained"
          color="primary"
          // disabled={!groupName.trim() || !parentGroup}
        >
          Update Notification Group
        </Button>
      </DialogActions>
    </Dialog>
  );
}
